// Tracker for Penetapan Predikat Kinerja v2
// https://docs.google.com/spreadsheets/d/1vEebeN1-GUEXEilJVug74YlZeNe0QvU_FpzvaG4PgtU/edit?gid=688477460#gid=688477460 (Sheet Penilaian Akhir Guru & KS)

import { getSession } from 'utils/auth'
import { useSatuEventTracker } from 'utils/satuEvent'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

import type { SETransformAttrsArgs } from 'utils/satuEvent'

const SATU_EVENT_NAME = 'guru_skp_pelaksanaan_fe_user_action_v1'
const DEFAULT_SCREEN_NAME: ScreenName = 'penilaian_akhir'

type TrackerParams = {
  // Event activity type
  activityType: ActivityType
  // Role of the actor
  role: Role
  // Whether the pegawai is a Plt KS
  isPlt?: boolean
}

type Role = 'ks' | 'tk' | 'ppk'
export type ScreenName = 'penilaian_akhir'

export type ActivityType =
  | 'view_hub'
  | 'view_tabel_pegawai'
  | 'view_pko'
  | 'save_multiple_predikat_kinerja'
  | 'send_predikat_kinerja'
  | 'view_rincian_pegawai'
  | 'save_predikat_kinerja'
  | 'view_recommendation'
  | 'view_kuadran_kinerja_pegawai'
  | 'view_praktik_kinerja'
  | 'view_perilaku_kerja'
  | 'view_pengembangan_kompetensi'
  | 'view_tabel_pegawai'

const usePenetapanTrackEvent = () => {
  const { periodYear } = usePeriodContext()
  const { SETrackEvent, SETransformAttrs } = useSatuEventTracker()
  const session = getSession()

  const trackEvent = (params: TrackerParams) => {
    const additionalAttributes: SETransformAttrsArgs = {}

    const role = params.role

    // Resolve KS type of the pegawai
    if (
      (role === 'tk' || role === 'ppk') &&
      typeof params.isPlt === 'boolean'
    ) {
      additionalAttributes['ks_type'] = [
        params.isPlt ? 'ks_plt' : 'ks',
        'string',
      ]
    }

    // Only add ptk_id for KS role
    if (role === 'ks') {
      additionalAttributes['ptk_id'] = [session?.user?.ptkId, 'string']
    }

    SETrackEvent({
      eventName: SATU_EVENT_NAME,
      eventParams: {
        screen_name: DEFAULT_SCREEN_NAME,
        activity_type: params.activityType,
        attributes: SETransformAttrs({
          role: [role, 'string'],
          year: [periodYear, 'string'],
          ...additionalAttributes,
        }),
        event_trace_id: '',
      },
      sendUserData: true,
      sendDefaultParams: true,
      sendAttributes: false,
    })
  }

  return {
    trackEvent,
  }
}

export default usePenetapanTrackEvent
